import { REALPERSON_ENV } from '@constants/env';
import {
  Client,
  SeqirusInstance,
  GSKInstance,
  HexalInstance,
  IncyteInstance,
  NovartisInstance,
} from './enums';
import { IClientConfig } from './interfaces';

const realPersonEnvironment = REALPERSON_ENV === 'prod' ? 'prod' : 'staging';

export const incyteConfig: IClientConfig = {
  clientName: Client.Incyte,
  deploymentTarget: {
    dev: 'https://incyte-app-dev.xircle.com',
    staging: 'https://incyte-app-staging.xircle.com',
    prod: 'https://incyte-app.xircle.com',
  },
  instances: [
    {
      name: IncyteInstance.Default,
      i18nNamespace: Client.Incyte,
      themeName: IncyteInstance.Default,
      isDefault: true,
      topics: [], // Empty array -> All topics enabled
    },
    {
      name: IncyteInstance.Onko,
      i18nNamespace: `${Client.Incyte}_${IncyteInstance.Onko}`,
      themeName: IncyteInstance.Onko,
      isDefault: false,
      topics: ['iclusig', 'pemazyre', 'minjuvi'],
    },
    {
      name: IncyteInstance.Derma,
      i18nNamespace: `${Client.Incyte}_${IncyteInstance.Derma}`,
      themeName: IncyteInstance.Derma,
      isDefault: false,
      topics: ['opzelura'],
    },
  ],
  devVersion: {
    major: 0,
    minor: 104,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 47,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const hexalConfig: IClientConfig = {
  clientName: Client.Hexal,
  deploymentTarget: {
    dev: 'https://hexal-app-dev.medinfo-assistant.com',
    staging: 'https://hexal-app-staging.medinfo-assistant.com',
    prod: 'https://hexal-app.medinfo-assistant.com',
  },
  instances: [
    {
      name: HexalInstance.Default,
      i18nNamespace: Client.Hexal,
      themeName: HexalInstance.Default,
      isDefault: true,
      topics: [], // Empty array -> All topics enabled
    },
  ],
  devVersion: {
    major: 0,
    minor: 136,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 71,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const novartisConfig: IClientConfig = {
  clientName: Client.Novartis,
  deploymentTarget: {
    dev: 'https://novartis-app-dev.xircle.com',
    staging: 'https://novartis-app-staging.xircle.com',
    prod: 'https://novartis-app.xircle.com',
  },
  instances: [
    {
      name: NovartisInstance.Default,
      i18nNamespace: Client.Novartis,
      themeName: NovartisInstance.Default,
      isDefault: true,
      topics: [], // Empty array -> All topics enabled
      liveChat: {
        realPerson: {
          enabled: true,
          environment: realPersonEnvironment,
          chatType: 'headless',
          targets: {
            staging: {
              host: 'https://staging720.realperson.de',
              departmentId: 20,
            },
            prod: {
              host: 'https://chat720.realperson.de',
              departmentId: 20,
            },
          },
        },
      },
    },
  ],
  devVersion: {
    major: 0,
    minor: 124,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 63,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const gskConfig: IClientConfig = {
  clientName: Client.GSK,
  deploymentTarget: {
    dev: 'https://gsk-app-dev.xircle.com',
    staging: 'https://gsk-app-staging.xircle.com',
    prod: 'https://gsk-app.xircle.com',
  },
  instances: [
    {
      name: GSKInstance.Default,
      i18nNamespace: Client.GSK,
      themeName: GSKInstance.Default,
      isDefault: true,
      topics: [], // Empty array -> All topics enabled
    },
  ],
  devVersion: {
    major: 0,
    minor: 110,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 50,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const seqirusConfig: IClientConfig = {
  clientName: Client.Seqirus,
  deploymentTarget: {
    dev: 'https://seqirus-app-dev.xircle.com',
    staging: 'https://seqirus-app-staging.xircle.com',
    prod: 'https://seqirus-app.xircle.com',
  },
  instances: [
    {
      name: SeqirusInstance.Default,
      i18nNamespace: Client.Seqirus,
      themeName: SeqirusInstance.Default,
      isDefault: true,
      topics: [], // Empty array -> All topics enabled
    },
  ],
  devVersion: {
    major: 0,
    minor: 104,
    patch: 0,
  },
  stagingVersion: {
    major: 0,
    minor: 47,
    patch: 0,
  },
  prodVersion: {
    major: 0,
    minor: 1,
    patch: 0,
  },
};

export const clientConfigs = [incyteConfig, hexalConfig, novartisConfig, gskConfig, seqirusConfig];
